import './Header.scss';

import React from 'react';
import { formatText } from 'core/i18n';

import CheckIcon from 'assets/icons/headline/check_bullet.svg';

export const Header = ({
    title,
    subtitle,
    collapsedSubtitle,
    icon,
    editIcon,
    editText,
    editAction,
    isCollapsed,
    isValidated,
}) => {
    const displayedSubtitle = isCollapsed ? collapsedSubtitle : subtitle;
    const shouldShowSubtitle = !(!isValidated && isCollapsed);
    const invalidHeaderClass = !isValidated && isCollapsed && 'initial-section-header--invalid';
    const invalidHeaderTextClass = !isValidated && isCollapsed && 'initial-section-header__info__text__title--invalid';

    const headerIcon =
        isCollapsed && isValidated ? (
            <img src={CheckIcon} alt={'Check icon'} />
        ) : (
            <img src={icon} alt={'Custom icon'} />
        );

    return (
        <div className={`initial-section-header ${invalidHeaderClass}`}>
            <div className="initial-section-header__info">
                {headerIcon}
                <div className="initial-section-header__info__texts">
                    <h4 className={`initial-section-header__info__texts__title ${invalidHeaderTextClass}`}>
                        {formatText(title)}
                    </h4>
                    {shouldShowSubtitle && (
                        <h6 className="initial-section-header__info__texts__subtitle">{displayedSubtitle}</h6>
                    )}
                </div>
            </div>
            {isCollapsed && isValidated && (
                <div className="initial-section-header__actions">
                    <img src={editIcon} alt={'edit-icon'} />
                    <button onClick={editAction}>{formatText(editText)}</button>
                </div>
            )}
        </div>
    );
};
